import { Action } from 'redux';
import { DeskListFilters, DeskModel } from '../../../api/core/core.types';
import { Page } from '../../../api/api.types';

export const GET_DESK_LIST = 'GET_DESK_LIST';
export const GET_DESK = 'GET_DESK';
export const PUT_DESK = 'PUT_DESK';
export const POST_DESK = 'POST_DESK';
export const DELETE_DESK = 'DELETE_DESK';
export const UPDATE_DESK_FILTERS = 'UPDATE_DESK_FILTERS';

export interface DeskState {
  desks: DeskModel[] | [];
  selectedDesk: DeskModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalPages: number;
  totalElements: number;
  filters: DeskListFilters | null;
}

export interface GetDeskListAction extends Action {
  type: typeof GET_DESK_LIST;
  payload: {
    page: Page<DeskModel>;
  };
}

export interface GetDeskAction extends Action {
  type: typeof GET_DESK;
  payload: {
    selectedDesk: DeskModel | null;
  };
}

export interface PutDeskAction extends Action {
  type: typeof PUT_DESK;
  payload: {
    selectedDesk: DeskModel;
  };
}

export interface PostDeskAction extends Action {
  type: typeof POST_DESK;
  payload: {
    selectedDesk: DeskModel;
    success: boolean;
  };
}

export interface DeleteDeskAction extends Action {
  type: typeof DELETE_DESK;
  payload: {
    success: boolean;
  };
}

export interface UpdateDeskFiltersAction extends Action {
  type: typeof UPDATE_DESK_FILTERS;
  payload: {
    filters: DeskListFilters;
  };
}

export type DeskActionTypes = GetDeskListAction | GetDeskAction | PutDeskAction | PostDeskAction | DeleteDeskAction | UpdateDeskFiltersAction;
